import React, {useEffect, useState, Fragment} from 'react';
import BreedItem from './../../components/ui/BreedItem';
import Pagination from '../../components/ui/Pagination';
import flatstore from 'flatstore';
import parse from 'html-react-parser';
import Loader from '../../components/ui/Loader';
import LoadModules from '../../components/ui/LoadModules';
import {getBreeds, getStaticPage} from '../../utils/services';
import DataFilter from '../../components/ui/DataFilter';
import Meta from '../../components/ui/Meta';
import {currentLang, accentsTidy, breedURL} from '../../utils/functions';
import {isNull, isNil} from 'lodash';
import NotFound from '../static/404';
import { useTranslation } from 'react-i18next';
import SearchState from '../../components/ui/SearchState';

const BreedsList = ({loading, breeds_data, breeds_list_static, page, filter}) => {
	const [data, setData] = useState();
	const [filteredData, setFilteredData] = useState([]);
	const [staticData, setStaticData] = useState();
	const [modules, setModules] = useState(null);
	const [filterType, setFilterType] = useState(null);
	const [activePage, setActivePage] = useState(1);
	const [searchStatus, setSearchStatus] = useState(null);
	const { t } = useTranslation();
	//console.log(page);
	
	useEffect(() => {
		//console.log(breeds_data);
		if (isNil(breeds_data)) {
			getBreeds();
			getStaticPage('breeds', 'breeds_list_static');
		}

		if(breeds_data){
			breeds_data.total = breeds_data.length;
			breeds_data.per_page = 9;
			setData(breeds_data.data);
			setFilterType(filter);
			if(page && page > 1){
				//i = (page-1)*breeds_data.per_page;
				setActivePage(page);
			}
		}
		
	}, [breeds_data]);

	useEffect(() => {
		if(breeds_list_static !== undefined){
			setStaticData(breeds_list_static);
			if(breeds_list_static.modules && breeds_list_static.modules.module !== null){
				setModules(breeds_list_static.modules);
			}
		}
	}, [breeds_list_static])
	
	useEffect(() => {
		//console.log(filter);
		if(data){
			//console.log(filter);
			setFilterType(filter);
		
			filterFunc({value:filter, pageNumber:page})
		}
	  }, [data, filter, page])


	const filterFunc = ({pageNumber, value, search, searchState}) =>{
		var per_page = 9;
		if(searchState == "search_empty"){
			setSearchStatus('only3char');
			setFilteredData([]);
			return false;
		}
		
		if(search && search.length > 0){
			search = search.toLowerCase();
			var fdata = [];
			if(search.length < 2){
				setSearchStatus('3char');
				setFilteredData(fdata);
			}else{
				data.map((item, index)=>{
					if(accentsTidy(item.title).includes(search)){
						fdata.push(item);
					}
				});
				if(fdata.length < 1){
					setSearchStatus('noresult');
					//console.log(fdata);
					setFilteredData(fdata);
				}else{
					fdata.total = 100;
					fdata.per_page = 1000;
					setFilteredData(fdata);
					setSearchStatus(null);
				}
				
			}
		}else{
			setSearchStatus(null);
			if(!pageNumber) pageNumber = 1;
			var fdata = [];
			var j = 0;
			var i = (pageNumber-1)*per_page;
			page = pageNumber;
			var total = 0;
			var id = 0;
			setActivePage(pageNumber);
			if(value != filterType){
				page = 1;
			}
			//console.log(value)
			setFilterType(value);
			data.map((item, index)=>{
				
				if(isNull(value)){
					if(j < per_page && id >= i){
						fdata.push(item);
						j++;
					}
					id++;
				}else{
					if(item.animal_types && item.animal_types.includes(value)){
						total++;
						if(j < per_page && id >= i){
							fdata.push(item);
							j++;
						}
						id++;
					}
				}
			})
			
			
			fdata.total = total;
			fdata.per_page = per_page;
			setFilteredData(fdata);
		}
	}

	if (loading) {
		return <Loader />
	} else {

		return (
			<Fragment>
			<LoadModules modules={modules} type="top" />
			<div className="container">
				<div className="row">
					<div className="col-12">
						<div className="back__row mt-30 mb-30">
							 <a href={"/"+currentLang()+"/"}> <span className="icon-back"></span> </a>
						</div>
					</div>
				</div>
			
				<div className="row">
					{staticData &&
						<Fragment>
						<Meta
							title={staticData.seo_title ? staticData.seo_title : staticData.title}
							description={staticData.seo_description ? staticData.seo_description : staticData.body}
						/>
						{staticData.body &&
							<div className="col-12 col-xxl-6 offset-xxl-3 col-lg-8 offset-lg-2 mb-10">
								<h1 className="heading--h1">{staticData.title}</h1>
								<p> {parse(staticData.body)}</p>
							</div>
						}
						</Fragment>
					}
				</div>

				<DataFilter type="breeds" filterType={filterType} filterFunc={filterFunc} data={data} />

				<div className="row">
					{filteredData && filteredData.map((item, index)=>{
						return (
							<div key={index} className="col-xs-12 col-md-6 col-lg-4">
								<BreedItem key={index} data={item} type={filterType} animal={t(filterType)} />
							</div>
						)
					})}
				</div>
				<SearchState status={searchStatus} />
				{data && filteredData && activePage && 
					<Pagination url={breedURL('')} data={filteredData} curPage={activePage} loadData={filterFunc} type="client" filterType={filterType} />
				}

			
			
		</div>
		<LoadModules modules={modules} type="bottom" />
		</Fragment>



		)
	}
}

export default flatstore.connect(['loading', 'breeds_data', 'breeds_list_static'])(BreedsList);